/**
 * Created by sagardesai on 11/07/18.
 */

export const BLOCK_UNBLOCK_VIEWER_REQUEST = "BLOCK_UNBLOCK_VIEWER_REQUEST";
export const BLOCK_UNBLOCK_VIEWER_RECEIVE = "BLOCK_UNBLOCK_VIEWER_RECEIVE";
export const BLOCK_UNBLOCK_VIEWER_FAILURE = "BLOCK_UNBLOCK_VIEWER_FAILURE";
export const RESET_BLOCK_UNBLOCK_VIEWER = "RESET_BLOCK_UNBLOCK_VIEWER";